import { LanguageDto, ProductKey } from "gast-common-ng2";

export const PortalProductLanguages = new Map<ProductKey, LanguageDto[]>([
  [
    "GENERAL",
    [
      { id: 1, code: "DE", name: "Deutsch" },
      { id: 2, code: "EN", name: "Englisch" },
    ],
  ],
  ["TESTDAF", [{ id: 1, code: "DE", name: "Deutsch" }]],
  [
    "TESTAS",
    [
      { id: 1, code: "DE", name: "Deutsch" },
      { id: 2, code: "EN", name: "Englisch" },
    ],
  ],
  [
    "DIGITAL_TESTAS",
    [
      { id: 1, code: "DE", name: "Deutsch" },
      { id: 2, code: "EN", name: "Englisch" },
    ],
  ],
  [
    "DMAT",
    [
      { id: 1, code: "DE", name: "Deutsch" },
      { id: 2, code: "EN", name: "Englisch" },
    ],
  ],
  [
    "ONSET",
    [
      { id: 1, code: "DE", name: "Deutsch" },
      { id: 2, code: "EN", name: "Englisch" },
    ],
  ],
  [
    "DUO",
    [
      { id: 1, code: "DE", name: "Deutsch" },
      { id: 2, code: "EN", name: "Englisch" },
    ],
  ],
  ["INL", [{ id: 6, code: "LB", name: "Luxemburgisch" }]],
  ["DTZ", [{ id: 1, code: "DE", name: "Deutsch" }]],
]);
